export default __webpack_public_path__ + "static/media/RunHorseLight_1_1.9c24f76c.jpg";